import { createActionCreator } from 'deox';

export const uiActions = {
  setDevice: createActionCreator('SET_DEVICE_ACTION', (resolve) => (deviceWidth: number) =>
    resolve({ deviceWidth }),
  ),
  persistCoordinate: createActionCreator(
    'PERSIST_COORDINATE_ACTION',
    (resolve) => (pathname: string, coordinate: { x: number; y: number }) =>
      resolve({ pathname, coordinate }),
  ),
  persistSelectedGroupApiHome: createActionCreator(
    'PERSIST_SELECTED_GROUP_API_HOME_ACTION',
    (resolve) => (name: string, coordinate: { x: number; y: number }) =>
      resolve({ name, coordinate }),
  ),
  setBankApiFooterInViewport: createActionCreator(
    'BANK_API_FOOTER_IN_VIEWPORT_ACTION',
    (resolve) => (footerInViewport: boolean) => resolve({ footerInViewport }),
  ),
};
